/* eslint-disable */
export default {
  rateExceeded:
    'Verzoeklimiet overschreden. De app wordt binnen {ttl} seconden hervat.',
} as const;

// @key: @#@"rateExceeded"@#@ @source: @#@"Request limit exceeded. App will resume in {ttl} seconds."@#@
